// extracted by mini-css-extract-plugin
export default {"moreText":"_15VGX","moreTextContainer":"EIlJJ"};